import { marketPlaceApi } from 'api'
import { RegionMarketsDTO } from 'types/applications/market'

export const fetchMarketsApi = () => marketPlaceApi.get<RegionMarketsDTO[]>('/dictionary/geographies')
